<div class="reason-div">
    <div class="reason-header">
        <span class="header-txt">Reason</span>
        <div style="color: var(--text-primary);" (click)="closeDialog()">
            <mat-icon class="close-icon">close</mat-icon>
        </div>
    </div>
    <span class="reason">{{data || 'No reason yet'}}</span>
</div>